export default __webpack_public_path__ + "static/media/stairs-cleaning.684559ee.jpeg";